import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet/hooks';
import L from 'leaflet';


function WorkingAreaBoundary() {
    const map = useMap();
    const layerRef = useRef(null);
    const hasAddedRef = useRef(false);

    useEffect(() => {
        // Only add the layer once
        if (hasAddedRef.current || !map) return;
        hasAddedRef.current = true;

        // Define the polygon coordinates for the working area
        const workingAreaCoordinates = [
            [
                [
                    [84.5487918869069, -70.10498515515441],
                    [84.5487918869069, 115.32416717682794],
                    [-52.133521429966706, 115.32416717682794],
                    [-52.133521429966706, -70.10498515515441],
                    [84.5487918869069, -70.10498515515441],
                ],
                [
                    [-11.249981069903486, 43.999989920353244],
                    [-11.250000344651305, 42.99999833521244],
                    [-11.750029064916419, 42.999985485380535],
                    [-11.750221812394559, 43.08349654274537],
                    [-12.162259006929148, 43.08215900681445],
                    [-12.163061210920185, 43.25126394772391],
                    [-12.49999022763586, 43.24999823928411],
                    [-12.49977820540989, 43.500043117767355],
                    [-12.499983802719914, 43.99985017843261],
                    [-12.749681735742506, 43.999952977087624],
                    [-12.750298527672575, 44.7497663667405],
                    [-11.749942328550723, 44.75006030664288],
                    [-11.750302123843264, 44.00034971564581],
                    [-11.249981069903486, 43.999989920353244],
                ],
                [
                    [9.408770082364109, 34.24990091676517],
                    [9.753808056873416, 34.24697686613372],
                    [9.750884006241982, 34.49552116980568],
                    [10.50090299320501, 34.49698319512139],
                    [10.499440967889297, 35.249195220058006],
                    [11.500197296497861, 35.24773319474229],
                    [11.499466283840002, 35.9999452196789],
                    [12.502415650422149, 35.99775218170532],
                    [12.499491599790712, 36.49776483968068],
                    [13.000966283081784, 36.49776483968068],
                    [13.0024283083975, 36.999239522971756],
                    [15.499933053971766, 36.99960502930067],
                    [15.500298560300712, 41.50008445740779],
                    [10.499989227382697, 41.49990170424334],
                    [10.500902993205031, 42.49919600753623],
                    [9.00013400662111, 42.499744267029605],
                    [8.999037487634322, 43.352105026092836],
                    [8.000108690670404, 43.348998222296984],
                    [8.002301728643983, 46.077137461425544],
                    [6.500070716744419, 46.077137461425565],
                    [6.501167235731207, 44.99925929741295],
                    [5.163414071849844, 45.001452335386546],
                    [5.156834957929115, 42.49700296956274],
                    [4.257689388762954, 42.49919600753632],
                    [4.242338122947922, 41.35443018532964],
                    [3.415695822330783, 41.35421381918859],
                    [3.415562806909768, 40.54958524902726],
                    [-1.716146051258085, 40.548488730040475],
                    [-1.722800070900735, 42.73455487286056],
                    [-0.33014605195805, 42.74591277956363],
                    [-0.343718452496689, 44.04184868099152],
                    [0.948462132418882, 44.030513763579975],
                    [0.944683826615035, 45.28868959626093],
                    [1.942156558830564, 45.303802819476324],
                    [1.938378253026717, 46.29371894008416],
                    [2.610717870607373, 46.28986214486245],
                    [2.612910908580949, 46.88417543570154],
                    [3.165556477922103, 46.885271954688335],
                    [3.167749515895679, 47.299756131694195],
                    [3.663376097923856, 47.30194916966777],
                    [3.665064005384658, 47.642574112057424],
                    [3.998910907880984, 47.6462561315192],
                    [4.000007426867773, 48.00152828323852],
                    [4.500020084843103, 47.99988350475833],
                    [4.503309641803468, 48.41327116277741],
                    [5.001129261805222, 48.411078124803836],
                    [5.003322299778796, 48.746612934760954],
                    [5.498948881806974, 48.746612934760954],
                    [5.49881181693363, 48.99936056121561],
                    [6.001565772375881, 48.9993605612156],
                    [6.000469253389094, 49.49827670020409],
                    [6.500207781617675, 49.49964734893756],
                    [6.499750898706516, 49.999111747419455],
                    [7.500507227314936, 49.99764972210374],
                    [7.500507227314937, 50.624858582546416],
                    [8.855804694984776, 50.611700354704986],
                    [8.861493920941824, 51.32138452973619],
                    [10.002032542507061, 51.32224465814354],
                    [10.00148428301359, 51.49860146185193],
                    [11.499877478459327, 51.49988073400319],
                    [11.500425737952709, 54.754166333625356],
                    [16.500552317705754, 54.736622029836745],
                    [16.50055231770576, 55.49979924464115],
                    [17.000564975681066, 55.49760620666758],
                    [17.00275801365464, 56.49324544667103],
                    [17.507156747577096, 56.49324544667103],
                    [17.502770671629943, 56.98448595275204],
                    [18.0071694055524, 56.993258104646344],
                    [18.011555481499553, 57.997669496544106],
                    [18.50279598758055, 57.997669496544106],
                    [18.50060294960698, 58.999887850468276],
                    [19.50227304403777, 58.99933959097487],
                    [19.502305070433582, 60.89356485437331],
                    [23.003692544739984, 60.91576240097085],
                    [23.001960821246627, 60.146877169888114],
                    [24.49816991956994, 60.14120971118234],
                    [24.49816991956994, 57.8175516418166],
                    [26.895504952110684, 57.82888655922815],
                    [26.88983749340492, 54.49783770491176],
                    [26.002880205951907, 54.49783770491176],
                    [26.000046476599017, 52.420714089247035],
                    [26.94367835110973, 52.42071408924703],
                    [26.943678351109725, 51.4997520495594],
                    [27.71445273509445, 51.4997520495594],
                    [27.72578765250599, 49.50480658512834],
                    [30.638861427271806, 49.51047404383411],
                    [30.63886142727181, 48.64335286185129],
                    [32.86758956331578, 48.63374966793317],
                    [32.871840157345204, 46.926112874002975],
                    [36.499617767909065, 46.93208842097996],
                    [36.50184745839092, 45.50074700950182],
                    [37.59283325925166, 45.5035807388547],
                    [37.57866461248721, 35.48351374705325],
                    [34.79594238795413, 35.50051612317056],
                    [34.80160984665991, 34.49737593224925],
                    [31.950878117657574, 34.50304339095502],
                    [31.962213035069116, 26.891646349105834],
                    [32.350124099118815, 26.891708684266526],
                    [32.35012409911881, 23.614911217567133],
                    [33.12606080758765, 23.61118969858166],
                    [33.13919775454123, 19.49998647152099],
                    [31.999366267776423, 19.497930498420757],
                    [32.004300603216976, 15.997841892597538],
                    [33.00103636220611, 16.000309060317807],
                    [33.00103636220609, 14.249442368166125],
                    [33.75516729536864, 14.244508032725578],
                    [33.74858818144793, 12.49884980576113],
                    [37.50032789473866, 12.499946324747915],
                    [37.500145141574166, 4.499561043987641],
                    [36.95505336969821, 4.49931737310169],
                    [36.94920526843535, 0.748735096519231],
                    [36.499997990181754, 0.749953450948994],
                    [36.500000369780246, -3.35014337e-07],
                    [36.00002358425283, -1.4791075198e-05],
                    [36.00005785047117, -1.250166367776232],
                    [35.75015432013882, -1.250063569121221],
                    [35.748509541658635, -3.501765308487736],
                    [36.0001606491262, -3.499298140767467],
                    [36.00000216786639, -6.00000178059635],
                    [35.74999583887884, -6.000001780596355],
                    [35.75000012215612, -6.249999543029333],
                    [35.49998950989116, -6.250020959415795],
                    [35.5001437078737, -6.383230883201377],
                    [35.07008928761843, -6.380066615384242],
                    [35.07008928761843, -6.949459020159944],
                    [34.24785049252504, -6.946773109973772],
                    [34.24980366697026, -7.750247397542729],
                    [33.69669550368151, -7.750298796870222],
                    [33.686826832800406, -9.000227643153657],
                    [32.99817864287916, -8.999765049206118],
                    [33.00002901866938, -9.750555026081775],
                    [31.750562766333484, -9.750555026081779],
                    [31.749637578438378, -10.250156489437114],
                    [29.500505805444263, -10.250156489437108],
                    [29.497730241758948, -11.501935711510757],
                    [28.49898990899582, -11.501935711510752],
                    [28.49898990899581, -12.251337906543752],
                    [27.24952365665994, -12.252263094438852],
                    [27.249523656659935, -10.501807596904976],
                    [26.248470354159082, -10.499957221114782],
                    [26.2503207299493, -12.250412718648658],
                    [23.498349335967, -12.250412718648654],
                    [23.500431008730995, -13.250078239306877],
                    [21.50017477951945, -13.249846942333102],
                    [21.499249591624352, -17.214277072847192],
                    [20.749731748104487, -17.21254234554388],
                    [20.749963045078278, -17.000211723617866],
                    [20.500046664913743, -17.000096075130976],
                    [20.50010448915718, -16.750237519209865],
                    [20.250130284749183, -16.750237519209858],
                    [20.249956812018848, -16.65656224483073],
                    [19.186915920546102, -16.662113372201343],
                    [19.188303702388758, -16.40884318591704],
                    [18.68731445719077, -16.410924858681017],
                    [18.68731445719076, -16.173614163587228],
                    [17.42651465313986, -16.168756927137938],
                    [17.425126871297216, -16.361658603266804],
                    [16.919974280571267, -16.358883039581496],
                    [16.919974280571264, -16.53651911544117],
                    [15.999874918891862, -16.544845806497094],
                    [15.999874918891862, -16.45810944133124],
                    [16.058855647204645, -16.45533387764593],
                    [16.05746786536199, -16.37831198537865],
                    [16.184202151663033, -16.378340782921033],
                    [16.18514379488613, -16.222186528080115],
                    [16.42600687089134, -16.221275663958007],
                    [16.434642753720915, -14.198320111128377],
                    [16.17988421024824, -14.19832011112838],
                    [16.17988421024824, -13.999694806047989],
                    [16.000568809813185, -14.00000085253086],
                    [16.00091575527384, -13.50109328009685],
                    [15.499926510075852, -13.50005244371486],
                    [15.49992651007585, -13.249904766576538],
                    [15.24995230566785, -13.24999150294171],
                    [15.250039042033016, -12.938694688361453],
                    [15.001086204010265, -12.941799159424162],
                    [15.000238310355355, -12.642403264954893],
                    [14.81705110712507, -12.643791046797547],
                    [14.816113668601975, -12.445519627061135],
                    [14.690607494114333, -12.445720093333533],
                    [14.694642304238878, -11.763599840513491],
                    [15.127914239879482, -11.762780873686248],
                    [15.130227209617239, -11.665173550752943],
                    [15.389279820245925, -11.663323174962741],
                    [15.390436305114806, -11.249995482825721],
                    [15.25003904203301, -11.249995482825723],
                    [15.25050163598056, -11.105666171189743],
                    [14.9997757164078, -11.10751654697995],
                    [14.999313122460253, -10.749931425522856],
                    [15.24980774505924, -10.750394019470408],
                    [15.249165253465588, -5.249149696200045],
                    [23.749997230976653, -5.249869286785129],
                    [23.755959552967333, -3.755690836194711],
                    [22.50058237796835, -3.750345306134117],
                    [22.51045104884944, -1.758929761253658],
                    [21.000544404042284, -1.750294674232701],
                    [21.001229728409022, 0.244958687101516],
                    [19.75339112144421, 0.247151725075092],
                    [19.750375694230545, 1.75020512621482],
                    [18.751721027013303, 1.748834477481336],
                    [18.7506245080265, 5.998942070271842],
                    [19.500277988660606, 6.000404095587561],
                    [19.499912482331677, 7.749717385843438],
                    [20.74738558296755, 7.748986373185579],
                    [20.750309633598974, 9.998555992302759],
                    [22.250347607525036, 9.999530675846568],
                    [22.25034760752504, 15.24917624281587],
                    [23.000122923602113, 15.249419913701816],
                    [22.999879252716163, 16.750188900285732],
                    [22.250043018917598, 16.74988431167829],
                    [22.249494759424195, 18.249983203325836],
                    [21.749969443220735, 18.249739532439882],
                    [21.749969443220735, 19.500014848264225],
                    [20.999950456257707, 19.499771177378253],
                    [20.999463114485796, 20.749802822316642],
                    [20.502374507141877, 20.749802822316635],
                    [20.500425140054254, 21.49835978396395],
                    [20.252855519926108, 21.500309151051574],
                    [20.250906152838475, 22.49838509991465],
                    [19.250393495115866, 22.499359783458452],
                    [19.250393495115866, 23.749878770168742],
                    [16.250073876377787, 23.749878770168745],
                    [16.248124509290175, 22.77787560610263],
                    [15.249073876883276, 22.781774340277877],
                    [15.250048560427075, 22.248622441812905],
                    [14.500029573464042, 22.250084467128627],
                    [14.500029573464035, 21.750071809153273],
                    [11.748497929283884, 21.747635100293742],
                    [11.749959954599593, 22.24959712535672],
                    [10.999453625864657, 22.248622441812913],
                    [11.000428309408468, 22.748635099788263],
                    [10.311327043933662, 22.749609783332073],
                    [10.311327043933662, 23.247673074219797],
                    [8.500121348645745, 23.24986611219336],
                    [8.49757150040677, 24.614836849973425],
                    [8.742493968637495, 24.614836849973425],
                    [8.753295399150813, 24.82178699747553],
                    [9.501852360798127, 24.825685731650776],
                    [9.499902993710498, 26.49921737637529],
                    [9.249896664722822, 26.499217376375295],
                    [9.250384006494727, 27.74583762891034],
                    [9.250384006494718, 31.86533762683008],
                    [10.287389537477466, 31.868309947575714],
                    [10.291833373057424, 33.64462243605816],
                    [9.408180677162042, 33.6424278264265],
                    [9.408770082364109, 34.24990091676517],
                ],
            ]
        ];

        // Create the polygon layer with a custom class name for identification
        const boundaryLayer = L.polygon(
            workingAreaCoordinates,
            {
                fillOpacity: 0.5,
                stroke: false,
                fillColor: '#505050',
                className: 'working-area-boundary',
                interactive: false,
            }
        );

        boundaryLayer.addTo(map);
        layerRef.current = boundaryLayer;

        // Cleanup: remove the layer when component unmounts
        return () => {
            if (layerRef.current && map.hasLayer(layerRef.current)) {
                map.removeLayer(layerRef.current);
            }
            hasAddedRef.current = false;
        };
    }, []); // Empty dependency array - only run once on mount

    return null;
}

export default WorkingAreaBoundary;
